export const getDataServiceUrl = (endpoint?: string): string => {
    const url = process.env.REACT_APP_DATASERVICE_URL ?? '';
    if (endpoint) {
        return `${url}${endpoint}`;
    }

    return `${url}`;
};

export const getDDWServiceUrl = () => {
    const url = process.env.REACT_APP_DDWSERVICE_URL ?? '';

    return `${url}`;
};